export interface Match {
  id: string;
  categoryId: string;
  homeTeam: string;
  awayTeam: string;
  homeLogo: string;
  awayLogo: string;
  homeScore: number | null;
  awayScore: number | null;
  status: "live" | "upcoming" | "finished";
  time: string;
  league: string;
  viewers: number;
  isHot: boolean;
}

export const matches: Match[] = [
  {
    id: "match-1",
    categoryId: "cat-1",
    homeTeam: "皇家马德里",
    awayTeam: "巴塞罗那",
    homeLogo: "https://readdy.ai/api/search-image?query=Real%20Madrid%20football%20club%20crest%20logo%20white%20and%20gold%20on%20white%20background%2C%20minimalist%20style%2C%20clean%20design&width=200&height=200&seq=team-logo-rm&orientation=squarish",
    awayLogo: "https://readdy.ai/api/search-image?query=Barcelona%20football%20club%20crest%20logo%20red%20blue%20and%20yellow%20on%20white%20background%2C%20minimalist%20style%2C%20clean%20design&width=200&height=200&seq=team-logo-barca&orientation=squarish",
    homeScore: 2,
    awayScore: 1,
    status: "live",
    time: "72'",
    league: "西甲联赛",
    viewers: 1250000,
    isHot: true,
  },
  {
    id: "match-2",
    categoryId: "cat-1",
    homeTeam: "曼彻斯特城",
    awayTeam: "利物浦",
    homeLogo: "https://readdy.ai/api/search-image?query=Manchester%20City%20football%20club%20crest%20logo%20sky%20blue%20and%20white%20on%20white%20background%2C%20minimalist%20style%2C%20clean%20design&width=200&height=200&seq=team-logo-manc&orientation=squarish",
    awayLogo: "https://readdy.ai/api/search-image?query=Liverpool%20football%20club%20crest%20logo%20red%20and%20white%20on%20white%20background%2C%20minimalist%20style%2C%20clean%20design&width=200&height=200&seq=team-logo-liver&orientation=squarish",
    homeScore: 1,
    awayScore: 1,
    status: "live",
    time: "58'",
    league: "英超联赛",
    viewers: 980000,
    isHot: true,
  },
  {
    id: "match-3",
    categoryId: "cat-2",
    homeTeam: "洛杉矶湖人",
    awayTeam: "金州勇士",
    homeLogo: "https://readdy.ai/api/search-image?query=LA%20Lakers%20basketball%20team%20logo%20purple%20and%20gold%20on%20white%20background%2C%20minimalist%20style%2C%20clean%20design&width=200&height=200&seq=team-logo-lakers&orientation=squarish",
    awayLogo: "https://readdy.ai/api/search-image?query=Golden%20State%20Warriors%20basketball%20team%20logo%20blue%20and%20gold%20on%20white%20background%2C%20minimalist%20style%2C%20clean%20design&width=200&height=200&seq=team-logo-warriors&orientation=squarish",
    homeScore: 98,
    awayScore: 92,
    status: "live",
    time: "Q3 4:22",
    league: "NBA常规赛",
    viewers: 850000,
    isHot: true,
  },
  {
    id: "match-4",
    categoryId: "cat-3",
    homeTeam: "张伟丽",
    awayTeam: "罗斯·娜玛尤纳斯",
    homeLogo: "https://readdy.ai/api/search-image?query=female%20MMA%20fighter%20silhouette%20red%20and%20gold%20on%20white%20background%2C%20minimalist%20style%2C%20clean%20martial%20arts%20design&width=200&height=200&seq=fighter-zhang&orientation=squarish",
    awayLogo: "https://readdy.ai/api/search-image?query=female%20MMA%20fighter%20silhouette%20blue%20and%20white%20on%20white%20background%2C%20minimalist%20style%2C%20clean%20martial%20arts%20design&width=200&height=200&seq=fighter-rose&orientation=squarish",
    homeScore: null,
    awayScore: null,
    status: "upcoming",
    time: "2026-09-15 10:00",
    league: "UFC 310",
    viewers: 0,
    isHot: true,
  },
  {
    id: "match-5",
    categoryId: "cat-1",
    homeTeam: "拜仁慕尼黑",
    awayTeam: "多特蒙德",
    homeLogo: "https://readdy.ai/api/search-image?query=Bayern%20Munich%20football%20club%20crest%20logo%20red%20and%20white%20on%20white%20background%2C%20minimalist%20style%2C%20clean%20design&width=200&height=200&seq=team-logo-bayern&orientation=squarish",
    awayLogo: "https://readdy.ai/api/search-image?query=Borussia%20Dortmund%20football%20club%20crest%20logo%20yellow%20and%20black%20on%20white%20background%2C%20minimalist%20style%2C%20clean%20design&width=200&height=200&seq=team-logo-dort&orientation=squarish",
    homeScore: 3,
    awayScore: 0,
    status: "finished",
    time: "2026-08-07 21:30",
    league: "德甲联赛",
    viewers: 720000,
    isHot: false,
  },
  {
    id: "match-6",
    categoryId: "cat-2",
    homeTeam: "广东宏远",
    awayTeam: "辽宁本钢",
    homeLogo: "https://readdy.ai/api/search-image?query=Guangdong%20Tigers%20basketball%20team%20logo%20blue%20and%20white%20on%20white%20background%2C%20minimalist%20style%2C%20clean%20design&width=200&height=200&seq=team-logo-gd&orientation=squarish",
    awayLogo: "https://readdy.ai/api/search-image?query=Liaoning%20basketball%20team%20logo%20orange%20and%20white%20on%20white%20background%2C%20minimalist%20style%2C%20clean%20design&width=200&height=200&seq=team-logo-ln&orientation=squarish",
    homeScore: null,
    awayScore: null,
    status: "upcoming",
    time: "2026-08-10 19:35",
    league: "CBA常规赛",
    viewers: 0,
    isHot: true,
  },
  {
    id: "match-7",
    categoryId: "cat-5",
    homeTeam: "JDG",
    awayTeam: "T1",
    homeLogo: "https://readdy.ai/api/search-image?query=JDG%20esports%20team%20logo%20red%20and%20black%20on%20white%20background%2C%20minimalist%20style%2C%20clean%20design&width=200&height=200&seq=team-logo-jdg&orientation=squarish",
    awayLogo: "https://readdy.ai/api/search-image?query=T1%20esports%20team%20logo%20red%20and%20gold%20on%20white%20background%2C%20minimalist%20style%2C%20clean%20design&width=200&height=200&seq=team-logo-t1&orientation=squarish",
    homeScore: 2,
    awayScore: 1,
    status: "live",
    time: "BO5 G4 22:15",
    league: "英雄联盟全球总决赛",
    viewers: 2100000,
    isHot: true,
  },
  {
    id: "match-8",
    categoryId: "cat-4",
    homeTeam: "郑钦文",
    awayTeam: "斯瓦泰克",
    homeLogo: "https://readdy.ai/api/search-image?query=female%20tennis%20player%20silhouette%20red%20and%20white%20on%20white%20background%2C%20minimalist%20style%2C%20clean%20tennis%20design&width=200&height=200&seq=player-zheng&orientation=squarish",
    awayLogo: "https://readdy.ai/api/search-image?query=female%20tennis%20player%20silhouette%20blue%20and%20white%20on%20white%20background%2C%20minimalist%20style%2C%20clean%20tennis%20design&width=200&height=200&seq=player-swiatek&orientation=squarish",
    homeScore: 1,
    awayScore: 0,
    status: "live",
    time: "Set 2 3-2",
    league: "WTA年终总决赛",
    viewers: 560000,
    isHot: false,
  },
  {
    id: "match-9",
    categoryId: "cat-6",
    homeTeam: "周冠宇",
    awayTeam: "汉密尔顿",
    homeLogo: "https://readdy.ai/api/search-image?query=F1%20racing%20driver%20helmet%20red%20and%20white%20on%20white%20background%2C%20minimalist%20style%2C%20clean%20racing%20design&width=200&height=200&seq=driver-zhou&orientation=squarish",
    awayLogo: "https://readdy.ai/api/search-image?query=F1%20racing%20driver%20helmet%20black%20and%20gold%20on%20white%20background%2C%20minimalist%20style%2C%20clean%20racing%20design&width=200&height=200&seq=driver-ham&orientation=squarish",
    homeScore: null,
    awayScore: null,
    status: "upcoming",
    time: "2026-08-16 20:00",
    league: "F1中国大奖赛",
    viewers: 0,
    isHot: true,
  },
  {
    id: "match-10",
    categoryId: "cat-1",
    homeTeam: "巴黎圣日耳曼",
    awayTeam: "马赛",
    homeLogo: "https://readdy.ai/api/search-image?query=PSG%20football%20club%20crest%20logo%20navy%20red%20and%20blue%20on%20white%20background%2C%20minimalist%20style%2C%20clean%20design&width=200&height=200&seq=team-logo-psg&orientation=squarish",
    awayLogo: "https://readdy.ai/api/search-image?query=Olympique%20Marseille%20football%20club%20crest%20logo%20white%20and%20blue%20on%20white%20background%2C%20minimalist%20style%2C%20clean%20design&width=200&height=200&seq=team-logo-mars&orientation=squarish",
    homeScore: null,
    awayScore: null,
    status: "upcoming",
    time: "2026-08-12 03:00",
    league: "法甲联赛",
    viewers: 0,
    isHot: false,
  },
  {
    id: "match-11",
    categoryId: "cat-2",
    homeTeam: "密尔沃基雄鹿",
    awayTeam: "波士顿凯尔特人",
    homeLogo: "https://readdy.ai/api/search-image?query=Milwaukee%20Bucks%20basketball%20team%20logo%20green%20and%20white%20on%20white%20background%2C%20minimalist%20style%2C%20clean%20design&width=200&height=200&seq=team-logo-bucks&orientation=squarish",
    awayLogo: "https://readdy.ai/api/search-image?query=Boston%20Celtics%20basketball%20team%20logo%20green%20and%20white%20on%20white%20background%2C%20minimalist%20style%2C%20clean%20design&width=200&height=200&seq=team-logo-celts&orientation=squarish",
    homeScore: 108,
    awayScore: 112,
    status: "finished",
    time: "2026-08-06 09:00",
    league: "NBA常规赛",
    viewers: 630000,
    isHot: false,
  },
  {
    id: "match-12",
    categoryId: "cat-3",
    homeTeam: "宋亚东",
    awayTeam: "彼得·严",
    homeLogo: "https://readdy.ai/api/search-image?query=male%20MMA%20fighter%20silhouette%20black%20and%20red%20on%20white%20background%2C%20minimalist%20style%2C%20clean%20martial%20arts%20design&width=200&height=200&seq=fighter-song&orientation=squarish",
    awayLogo: "https://readdy.ai/api/search-image?query=male%20MMA%20fighter%20silhouette%20white%20and%20blue%20on%20white%20background%2C%20minimalist%20style%2C%20clean%20martial%20arts%20design&width=200&height=200&seq=fighter-petr&orientation=squarish",
    homeScore: null,
    awayScore: null,
    status: "upcoming",
    time: "2026-09-20 08:00",
    league: "UFC格斗之夜",
    viewers: 0,
    isHot: true,
  },
];